"use client";

import React, { useState } from "react";
import styles from "./listing-description.module.css";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";

interface ListingDescriptionProps {
  description: string;
}

export default function ListingDescription({
  description,
}: ListingDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!description) return null;

  // We can determine if we need the toggle based on character count.
  const CHARACTER_LIMIT = 400;
  const isLongText = description.length > CHARACTER_LIMIT;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Descriere</h2>

      <div
        className={`${styles.textContent} ${!isExpanded && isLongText ? styles.collapsed : ""}`}
        // Using dangerouslySetInnerHTML if your description contains HTML (like <br/> or <p>).
        // If it's pure string, you can just render it directly.
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {isLongText && (
        <button
          className={styles.toggleButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Ascunde" : "Citește mai mult"}
          {isExpanded ? (
            <IoChevronUpOutline className={styles.icon} />
          ) : (
            <IoChevronDownOutline className={styles.icon} />
          )}
        </button>
      )}
    </div>
  );
}
